import React from "react";

import * as moment from "moment";

import { Feed, Icon, Popup } from "semantic-ui-react";

import { connect } from "react-redux";

import { requestOpenReimbursementModal } from "../actions/reimbursements";

const actionToDescription = {
  submit: {
    icon: "arrow right",
    color: "grey",
    sentence: (reimbursement, actor, submitter) => (
      <span>
        {submitter.name} submitted a reimbursement for {reimbursement}.
      </span>
    ),
    sentenceSimple: (actor, submitter) => (
      <span>Submitted by {submitter.name}</span>
    )
  },
  approve: {
    icon: "check",
    color: "green",
    sentence: (reimbursement, actor, submitter) => (
      <span>
        {reimbursement} ({submitter.name}) was approved by {actor}.
      </span>
    ),
    sentenceSimple: (actor, submitter) => <span>Approved by {actor}</span>
  },
  unapprove: {
    icon: "undo",
    color: "grey",
    sentence: (reimbursement, actor, submitter) => (
      <span>
        {reimbursement} ({submitter.name}) was un-approved by {actor}.
      </span>
    ),
    sentenceSimple: (actor, submitter) => (
      <span>Approval revoked by {actor}</span>
    )
  },
  reject: {
    icon: "times",
    color: "red",
    sentence: (reimbursement, actor, submitter) => (
      <span>
        {reimbursement} ({submitter.name}) was rejected by {actor}.
      </span>
    ),
    sentenceSimple: (actor, submitter) => <span>Rejected by {actor}</span>
  },
  unreject: {
    icon: "undo",
    color: "grey",
    sentence: (reimbursement, actor, submitter) => (
      <span>
        {reimbursement} ({submitter.name}) was un-rejected by {actor}.
      </span>
    ),
    sentenceSimple: (actor, submitter) => (
      <span>Rejection removed by {actor}</span>
    )
  },
  pay: {
    icon: "dollar sign",
    color: "green",
    sentence: (reimbursement, actor, submitter) => (
      <span>
        {reimbursement} was paid out to {submitter.name} by {actor}.
      </span>
    ),
    sentenceSimple: (actor, submitter) => <span>Paid out by {actor}</span>
  }
};

const ReimbursementLogItem = props => {
  const simple = !!props.reimbursement;
  const reimbursement = props.reimbursement || props.item.reimbursement;
  const item = props.item;
  const shorthand = actionToDescription[item.action];
  const modal = (
    <a onClick={() => props.requestOpenModal(reimbursement.uuid)}>
      {reimbursement.description}
    </a>
  );
  const description = simple
    ? shorthand.sentenceSimple(item.user, reimbursement.submitter)
    : shorthand.sentence(modal, item.user, reimbursement.submitter);
  return (
    <Feed.Event>
      <Feed.Label>
        <Icon name={shorthand.icon} color={shorthand.color} />
      </Feed.Label>
      <Feed.Content>
        <Feed.Summary>
          {description}
          <Feed.Date>
            <Popup
              size="mini"
              inverted
              trigger={<span>{moment(item.timestamp).calendar()}</span>}
              content={moment(item.timestamp).format("llll")}
            />
          </Feed.Date>
        </Feed.Summary>
      </Feed.Content>
    </Feed.Event>
  );
};

const mapDispatchToProps = dispatch => ({
  requestOpenModal: reimbursementUUID =>
    dispatch(requestOpenReimbursementModal(reimbursementUUID))
});

const ConnectedReimbursementLogItem = connect(
  null,
  mapDispatchToProps
)(ReimbursementLogItem);

const ReimbursementLog = props => (
  <Feed>
    {props.items.map((item, i) => (
      <ConnectedReimbursementLogItem
        item={item}
        key={i}
        reimbursement={props.reimbursement}
      />
    ))}
    {props.items.length === 0 && <div>There are no items to show</div>}
  </Feed>
);

export default ReimbursementLog;



// WEBPACK FOOTER //
// ./frontend/src/components/ReimbursementLog.js